<template>
    <div>
        <div class="flex flex-wrap items-center justify-between gap-2 mb-2">
            <span class="font-bold">{{ props.qualification.usecase }}</span>
            <span class="text-sm text-slate-500" data-test="fees">
                monthly {{ feeLabel(props.qualification.monthly_fee) }} · quarterly
                {{ feeLabel(props.qualification.quarterly_fee) }} · annual
                {{ feeLabel(props.qualification.annual_fee) }}
            </span>
        </div>
        <vx-table class="xl:grid-cols-5" rowBreakpoint="xl">
            <vx-table-row isHeader>
                <div>Carrier</div>
                <div>Qualify</div>
                <div>Review</div>
                <div>Class / TPM</div>
                <div>Tier / Daily cap</div>
            </vx-table-row>
            <vx-table-row
                v-for="(terms, mnoId) in props.qualification.mno_metadata"
                :key="mnoId"
                :data-test="`carrier-${mnoId}`"
            >
                <vx-table-row-title>{{ mnoLabel(mnoId, terms.mno) }}</vx-table-row-title>
                <vx-table-row-item>
                    <template v-slot:label> Qualify: </template>
                    {{ yesNo(terms.qualify) }}
                </vx-table-row-item>
                <vx-table-row-item>
                    <template v-slot:label> Review: </template>
                    {{ yesNo(terms.mno_review) }}
                </vx-table-row-item>
                <vx-table-row-item>
                    <template v-slot:label> Class / TPM: </template>
                    {{ carrierClassLabel(terms) }}
                </vx-table-row-item>
                <vx-table-row-item>
                    <template v-slot:label> Tier / Daily cap: </template>
                    {{ carrierTierLabel(terms) }}
                </vx-table-row-item>
            </vx-table-row>
        </vx-table>
    </div>
</template>

<script lang="ts" setup>
import { VxTable, VxTableRow, VxTableRowItem, VxTableRowTitle } from '@voxie/frontend-components';
import {
    carrierClassLabel,
    carrierTierLabel,
    feeLabel,
    mnoLabel,
    yesNo,
} from '~/components/kiosk/kiosk-ten-dlc/registration/tenDlcRegistrationLabels';
import type { TcrUsecaseQualification } from '~/services/adminTenDlcRegistrationClient.types';

const props = defineProps<{ qualification: TcrUsecaseQualification }>();
</script>
